import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetErrorJobApplicationSubmitted } from '../../../redux/actions/jobs';

export const useRestJobApplication = () => {
  const dispatch = useDispatch();
  useEffect(
    () => () => {
      dispatch(resetErrorJobApplicationSubmitted());
    },
    [dispatch],
  );
};
